import { ErrorPage } from '../components/ErrorPage';

export const PageNotFound = () => {
    return (
        <ErrorPage code={404} message="Page Not Found" />
    );
};
